import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';

const CadastroPublicoPage = React.lazy(() => import('views/cadastro-publico'));

const Routes = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const redirect = urlParams.get('redirect');
	const targetRoute = redirect && redirect !== '/' ? redirect : AUTHENTICATED_ENTRY;
	return (
		<RouterRoutes>
			<Route
				path="/cadastro/:token"
				element={<AppRoute routeKey="cadastro-publico" component={CadastroPublicoPage} blankLayout={true} />}
			/>
			<Route path="/" element={<ProtectedRoute />}>
				<Route path="/" element={<Navigate replace to={targetRoute} />} />
				{protectedRoutes.map((route, index) => {
					return (
						<Route 
							key={route.key + index} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
				<Route path="*" element={<Navigate to="/" replace />} />
			</Route>
			<Route path="/" element={<PublicRoute />}>
				{publicRoutes.map(route => {
					return (
						<Route 
							key={route.path} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/ >
					)
				})}
			</Route>
		</RouterRoutes>
	)
}

export default Routes